function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["value", "onChange", "placeholder", "disabled", "error", "type"],
  _excluded2 = ["value", "onChange", "placeholder", "rows", "disabled", "error"],
  _excluded3 = ["value", "onChange", "options", "placeholder", "disabled", "error", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { colors, spacing, typography } from '../tokens';

/**
 * FormField — wraps a label, any input child, optional helper text, and error text.
 *
 * Props:
 *   label       — string field label
 *   helperText  — string hint shown below the input
 *   error       — string validation error (shown instead of helperText)
 *   children    — the input element(s)
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function FormField(_ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    error = _ref.error,
    children = _ref.children;
  var containerStyle = {
    fontFamily: typography.fontFamily,
    marginBottom: spacing.md
  };
  var labelStyle = {
    display: 'block',
    fontSize: typography.sizes.sm,
    fontWeight: 600,
    color: colors.neutral[700],
    marginBottom: spacing.xs
  };
  var helperStyle = {
    fontSize: '0.75rem',
    color: colors.neutral[500],
    marginTop: spacing.xs
  };
  var errorStyle = {
    fontSize: '0.75rem',
    color: colors.danger[500],
    marginTop: spacing.xs,
    fontWeight: 500
  };
  return /*#__PURE__*/_jsxs("div", {
    style: containerStyle,
    children: [label && /*#__PURE__*/_jsx("label", {
      style: labelStyle,
      children: label
    }), children, error ? /*#__PURE__*/_jsx("p", {
      style: errorStyle,
      children: error
    }) : helperText ? /*#__PURE__*/_jsx("p", {
      style: helperStyle,
      children: helperText
    }) : null]
  });
}

/**
 * TextInput — single-line text input styled with design tokens.
 *
 * Props: value, onChange, placeholder, disabled, error, type ('text' | 'email' | 'number' | …), + any native input prop.
 */
export function TextInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    placeholder = _ref2.placeholder,
    disabled = _ref2.disabled,
    error = _ref2.error,
    _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? 'text' : _ref2$type,
    props = _objectWithoutProperties(_ref2, _excluded);
  var inputStyle = {
    width: '100%',
    padding: "".concat(spacing.sm, " ").concat(spacing.md),
    borderRadius: '6px',
    border: "1px solid ".concat(error ? colors.danger[500] : colors.neutral[200]),
    fontSize: typography.sizes.sm,
    fontFamily: typography.fontFamily,
    height: '42px',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: disabled ? colors.neutral[100] : 'var(--bafkal-bg-surface)',
    color: colors.neutral[900],
    cursor: disabled ? 'not-allowed' : 'text'
  };
  return /*#__PURE__*/_jsx("input", _objectSpread({
    type: type,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    disabled: disabled,
    style: inputStyle
  }, props));
}

/**
 * Textarea — multi-line text input styled with design tokens.
 *
 * Props: value, onChange, placeholder, rows (default 3), disabled, error, + any native textarea prop.
 */
export function Textarea(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange,
    placeholder = _ref3.placeholder,
    _ref3$rows = _ref3.rows,
    rows = _ref3$rows === void 0 ? 3 : _ref3$rows,
    disabled = _ref3.disabled,
    error = _ref3.error,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var style = {
    width: '100%',
    padding: "".concat(spacing.sm, " ").concat(spacing.md),
    borderRadius: '6px',
    border: "1px solid ".concat(error ? colors.danger[500] : colors.neutral[200]),
    fontSize: typography.sizes.sm,
    fontFamily: typography.fontFamily,
    outline: 'none',
    boxSizing: 'border-box',
    resize: 'vertical',
    backgroundColor: disabled ? colors.neutral[100] : 'var(--bafkal-bg-surface)',
    color: colors.neutral[900],
    cursor: disabled ? 'not-allowed' : 'text'
  };
  return /*#__PURE__*/_jsx("textarea", _objectSpread({
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    rows: rows,
    disabled: disabled,
    style: style
  }, props));
}

/**
 * Select — dropdown styled with design tokens.
 *
 * Two usage modes:
 *   1. options prop: Pass an array of { value, label } (or plain strings).
 *      A `placeholder` prop adds an initial disabled empty option.
 *   2. children prop: Render <option> / <optgroup> elements directly for
 *      complex or dynamic option sets (e.g. filtered, formatted labels).
 *
 * Props: value, onChange, options?, placeholder?, disabled, error, children?, + any native select prop.
 */
export function Select(_ref4) {
  var value = _ref4.value,
    onChange = _ref4.onChange,
    options = _ref4.options,
    placeholder = _ref4.placeholder,
    disabled = _ref4.disabled,
    error = _ref4.error,
    children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded3);
  var selectStyle = {
    width: '100%',
    padding: "".concat(spacing.sm, " ").concat(spacing.md),
    borderRadius: '6px',
    border: "1px solid ".concat(error ? colors.danger[500] : colors.neutral[200]),
    fontSize: typography.sizes.sm,
    fontFamily: typography.fontFamily,
    height: '42px',
    backgroundColor: disabled ? colors.neutral[100] : 'var(--bafkal-bg-surface)',
    color: colors.neutral[900],
    outline: 'none',
    boxSizing: 'border-box',
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
  return /*#__PURE__*/_jsxs("select", _objectSpread(_objectSpread({
    value: value,
    onChange: onChange,
    disabled: disabled,
    style: selectStyle
  }, props), {}, {
    children: [placeholder && /*#__PURE__*/_jsx("option", {
      value: "",
      disabled: true,
      children: placeholder
    }), options ? options.map(function (opt) {
      var _opt$value, _opt$value2, _opt$label;
      return /*#__PURE__*/_jsx("option", {
        value: (_opt$value2 = opt.value) !== null && _opt$value2 !== void 0 ? _opt$value2 : opt,
        children: (_opt$label = opt.label) !== null && _opt$label !== void 0 ? _opt$label : opt
      }, (_opt$value = opt.value) !== null && _opt$value !== void 0 ? _opt$value : opt);
    }) : children]
  }));
}

/**
 * ToggleSwitch — styled checkbox that renders as a toggle.
 *
 * Props:
 *   checked   — boolean current state
 *   onChange  — called with a synthetic event { target: { name, type, checked } }
 *               so it can be used alongside a standard React form handleChange.
 *               When name is omitted, onChange receives the boolean directly
 *               for backwards-compatible usage.
 *   label     — string label rendered next to the toggle
 *   name      — string field name (required for event-compatible onChange)
 */
export function ToggleSwitch(_ref5) {
  var checked = _ref5.checked,
    onChange = _ref5.onChange,
    label = _ref5.label,
    name = _ref5.name,
    id = _ref5.id;
  var handleChange = function handleChange(e) {
    if (name !== undefined) {
      // Event-compatible mode: mirrors the native event shape
      onChange({
        target: {
          name: name,
          type: 'checkbox',
          checked: e.target.checked,
          value: e.target.checked
        }
      });
    } else {
      // Legacy boolean mode
      onChange(e.target.checked);
    }
  };
  return /*#__PURE__*/_jsxs("label", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      gap: spacing.sm,
      fontFamily: typography.fontFamily
    },
    children: [/*#__PURE__*/_jsx("input", {
      type: "checkbox",
      id: id || name,
      name: name,
      checked: checked,
      onChange: handleChange,
      style: {
        width: '18px',
        height: '18px',
        cursor: 'pointer',
        accentColor: colors.primary[600]
      }
    }), label && /*#__PURE__*/_jsx("span", {
      style: {
        fontSize: typography.sizes.sm,
        color: colors.neutral[800]
      },
      children: label
    })]
  });
}